import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { HeaderLogo } from "@/components/Brand";
import { Input } from "@/components/ui/input";
import { staffApi, errMsg } from "@/lib/api";
import { staffKey } from "./StaffScreen";

const F = ({ label, hint, children }) => (
  <label className="mt-4 block"><span className="text-sm font-semibold">{label}</span>{children}{hint && <span className="mt-1 block text-xs text-muted2">{hint}</span>}</label>
);

export default function StaffJoin() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [f, setF] = useState({ code: (params.get("code") || "").toUpperCase(), display_name: "", contact: "", secret: "", confirm: "" });
  const [invite, setInvite] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: k === "code" ? e.target.value.toUpperCase().trim() : e.target.value });
  useEffect(() => { document.title = "Join your venue · LineGone"; }, []);
  useEffect(() => {
    if (f.code.length < 8) { setInvite(null); return; }
    staffApi().get(`/invites/${f.code}`).then((r) => setInvite(r.data)).catch(() => setInvite({ state: "missing" }));
  }, [f.code]);
  const submit = async (e) => {
    e.preventDefault();
    if (f.secret !== f.confirm) return toast.error("Passwords don't match");
    try {
      const r = await staffApi().post("/register", { code: f.code, display_name: f.display_name, contact: f.contact, secret: f.secret });
      localStorage.setItem(staffKey(r.data.venue.slug), r.data.token);
      toast.success(`Welcome to ${r.data.venue.name}, ${r.data.name}!`);
      nav(`/staff/${r.data.venue.slug}`);
    } catch (err) { toast.error(errMsg(err)); }
  };
  const ok = invite?.state === "active";
  return (
    <div className="min-h-screen bg-white">
      <header className="flex h-14 items-center border-b border-line px-4"><HeaderLogo className="h-6" /></header>
      <form onSubmit={submit} className="mx-auto max-w-sm px-4 py-10" data-testid="staff-join-form">
        <div className="eyebrow">LineGone staff</div>
        <h1 className="mt-1 text-3xl font-black">Join your venue</h1>
        <p className="mt-1 text-sm text-muted2">Your manager gives you a one-time invite code.</p>
        <F label="Invite code"><Input className="mt-1 font-mono tracking-widest" value={f.code} maxLength={8} onChange={set("code")} data-testid="join-code-input" /></F>
        {invite && <p className={`mt-2 text-sm font-semibold ${ok ? "text-brand" : "text-danger"}`} data-testid="join-invite-status">
          {ok ? `Joining ${invite.venue}` : { used: "This code was already used.", expired: "This code has expired. Ask for a new one.", revoked: "This code was cancelled.", missing: "Code not found." }[invite.state]}</p>}
        <F label="Display name" hint="Only your first name is shown to customers, e.g. “Prepared by Ada”."><Input className="mt-1" value={f.display_name} onChange={set("display_name")} data-testid="join-name-input" /></F>
        <F label="Email or mobile phone" hint="You'll use this to sign in. Never shown to customers."><Input className="mt-1" value={f.contact} onChange={set("contact")} data-testid="join-contact-input" /></F>
        <F label="Password or PIN" hint="A 4–8 digit PIN, or a password of 8+ characters."><Input className="mt-1" type="password" value={f.secret} onChange={set("secret")} data-testid="join-secret-input" /></F>
        <F label="Confirm password or PIN"><Input className="mt-1" type="password" value={f.confirm} onChange={set("confirm")} data-testid="join-confirm-input" /></F>
        <button className="btn-primary mt-6 w-full" disabled={!ok || !f.display_name.trim() || f.contact.length < 3 || f.secret.length < 4} data-testid="join-submit-btn">Create my staff account</button>
      </form>
    </div>
  );
}
